// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../_redux/adminDashboard/adminDashboardActions";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../../_metronic/_helpers";
import * as uiHelpers from "./AdminDashboardUIHelpers";
import UnmappedFilesTableAction from "./UnmappedFilesTableAction";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { useAdminDashboardUIContext } from "./AdminDashboardUIContext";
import { DateFormatter } from "../../../formatters/CustomFormatters";
import { DateTimeFormatter } from "../../../formatters/CustomFormatters";
export default function UnmappedFilesTable() {
  // Customers UI Context
  const adminDashboardUIContext = useAdminDashboardUIContext();
  const adminDashboardUIProps = useMemo(() => {
    return {
      queryParams: adminDashboardUIContext.queryParams,
      setQueryParams: adminDashboardUIContext.setQueryParams,
    };
  }, [adminDashboardUIContext]);

  // Getting curret state of customers list from store (Redux)
  const { adminDashboard } = useSelector((state) => state, shallowEqual);

  const { listLoading, totalCount, unMappedFiles } = adminDashboard;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.fetchUnmappedFiles(adminDashboardUIProps.queryParams));
  }, [adminDashboardUIProps.queryParams, dispatch]);
  // Table columns
  const columns = [
    {
      dataField: "fileUrl",
      text: "document link",
    },
    {
      dataField: "time",
      formatter: DateTimeFormatter,
      text: "time",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "accountName",
      text: "account name",
    },
    // {
    //   dataField: "notes",
    //   text: "notes",
    // },
    {
      dataField: "action",
      text: "Actions",
      formatter: UnmappedFilesTableAction,
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];
  // Table pagination properties
  const paginationOptionsss = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: adminDashboardUIProps.queryParams.pageSize,
    page: adminDashboardUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptionsss)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                remote
                keyField="_id"
                data={unMappedFiles === null ? [] : unMappedFiles}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  adminDashboardUIProps.setQueryParams
                )}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={unMappedFiles} />
                <NoRecordsFoundMessage entities={unMappedFiles} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
